import * as React from "react";

import { cn } from "@repo/ui/lib/utils";
import { Languages } from "lucide-react";

export type MediaDayStatusLanguage = "en" | "pl";

const polish = {
  "Media Day date": "Data Media Day",
  "Media Day Status": "Status Media Day",
  Language: "Język",
  "Link unavailable": "Link niedostępny",
  "Media Day status link is not active.": "Link do statusu Media Day nie jest aktywny.",
  "Filter by person": "Filtruj po osobie",
  Filtering: "Filtrowanie",
  people: "osób",
  "photo tasks": "zadań zdjęciowych",
  "No assignments": "Brak przypisań",
  "No assignments yet": "Nie ma jeszcze przypisań",
  "Photographic Studios": "Studia fotograficzne",
  "players done": "graczy gotowych",
  "teams done": "teamów gotowych",
  View: "Pokaż",
  "View details": "Pokaż szczegóły",
  Hide: "Ukryj",
  "Hide details": "Ukryj szczegóły",
  "Clear filter": "Wyczyść filtr",
  Person: "Osoba",
  Cutout: "Cutout",
  Editorial: "Editorial",
  Editor: "Edytor",
  Cropper: "Cropper",
  Overall: "Łącznie",
  "photos done": "gotowych zdjęć",
  "No work for this assignee": "Brak pracy dla tej osoby",
  "No work found for": "Nie znaleziono pracy dla",
  "in this set": "w tym secie",
  No: "Brak",
  cutout: "cutoutów",
  editorial: "editoriali",
  "entries queued for this board": "w kolejce dla tej tablicy",
  Player: "Gracz",
  Position: "Pozycja",
  entries: "pozycji",
  "players shot": "graczy sfotografowanych",
  "No teams queued for this set.": "Brak teamów w kolejce dla tego setu.",
  "Clear assignee filter": "Wyczyść filtr osoby",
  "Swipe table horizontally to see all columns":
    "Przesuń tabelę poziomo, aby zobaczyć wszystkie kolumny",
  "min break": "min przerwy",
  "Team not assigned yet": "Team nie został jeszcze przypisany",
  "Photoshoot Start": "Początek sesji",
  "Pictures available": "Zdjęcia dostępne",
  "Edit deadline": "Termin edycji",
  "Set time": "Ustaw godzinę",
  "Photoshoot start time": "Godzina rozpoczęcia sesji",
  "Planned photos": "Planowane zdjęcia",
  player: "gracz",
  team: "team",
  "across all people": "dla wszystkich osób",
  teams: "teamy",
  photos: "zdjęcia",
  "not shot": "bez zdjęć",
  "Download photos": "Pobierz zdjęcia",
  "Upload photos": "Prześlij zdjęcia",
  Pending: "Oczekuje",
  Done: "Gotowe",
  Shot: "Zdjęcia zrobione",
  "Files ready to download": "Pliki gotowe do pobrania",
  Edited: "Edytowane",
  "Cut out": "Wycięte",
  Cropped: "Wykadrowane",
  Teamcomp: "Teamcomp",
  Verified: "Zweryfikowane",
  "Set as captain": "Ustaw jako kapitana",
  "Unset captain": "Usuń kapitana",
  "selected as captain": "wybrano jako kapitana",
  "is no longer captain": "nie jest już kapitanem",
  "Remove captain": "Usuń kapitana",
  "No show": "Nieobecny",
  "Player was absent for the whole day.": "Gracz był nieobecny przez cały dzień.",
  "Set as no show": "Ustaw jako nieobecny",
  "Unset no show": "Usuń nieobecność",
  "marked as no show": "oznaczono jako nieobecnego",
  "Restore attendance": "Przywróć obecność",
  "attendance restored": "przywrócono obecność",
  restored: "przywrócono",
  "Edit notes": "Edytuj notatki",
  "Add note": "Dodaj notatkę",
  "Only WorkGrid admins can edit player details.":
    "Tylko administratorzy WorkGrid mogą edytować dane gracza.",
  "Latest note": "Najnowsza notatka",
  "Player notes": "Notatki gracza",
  "the player": "gracza",
  "Notes for": "Notatki dla",
  "They appear as a note indicator on the status board.":
    "Są widoczne jako ikona notatki na tablicy statusu.",
  Note: "Notatka",
  "Player note added.": "Dodano notatkę gracza.",
  "Player note updated.": "Zaktualizowano notatkę gracza.",
  "Player note deleted.": "Usunięto notatkę gracza.",
  Delete: "Usuń",
  "Save changes": "Zapisz zmiany",
  "No notes yet.": "Brak notatek.",
  "Add another note": "Dodaj kolejną notatkę",
  "What should editors know about this player?": "Co edytorzy powinni wiedzieć o tym graczu?",
  Close: "Zamknij",
  done: "gotowe",
  pending: "oczekuje",
  "team status": "status teamu",
  "This team status cannot be changed": "Tego statusu teamu nie można zmienić",
  "Only WorkGrid admins can change this status":
    "Tylko administratorzy WorkGrid mogą zmienić ten status",
  "Only WorkGrid admins can edit the editor":
    "Tylko administratorzy WorkGrid mogą edytować edytora",
  "Only WorkGrid admins can edit the cropper":
    "Tylko administratorzy WorkGrid mogą edytować croppera",
  "Automatically controlled by Voxis verification":
    "Automatycznie kontrolowane przez weryfikację Voxis",
  previously: "wcześniej",
  "Retouched and color-graded JPGs, ready for cutout editors to download.":
    "Wyretuszowane pliki JPG po korekcji kolorów, gotowe do pobrania przez edytorów cutoutów.",
  "Selected editorial JPG or RAW files, ready for editorial editors to download.":
    "Wybrane pliki editorial JPG lub RAW, gotowe do pobrania przez edytorów.",
  "High-resolution edited editorial JPG files uploaded by the editorial editors.":
    "Edytowane pliki editorial JPG w wysokiej rozdzielczości przesłane przez edytorów.",
  "All expected source and edited editorial files are present for people marked Shot, including the team photo when required.":
    "Wszystkie oczekiwane pliki źródłowe i edytowane są dostępne dla sfotografowanych osób, razem ze zdjęciem teamu, gdy jest wymagane.",
  "Full-body cutout PNGs uploaded by cutout editors. They retain their source dimensions and are not scaled to 4K.":
    "Pełne cutouty PNG przesłane przez edytorów. Zachowują oryginalne wymiary i nie są skalowane do 4K.",
  "Individual cutouts cropped to head and torso, then scaled to a 4K canvas.":
    "Cutouty wykadrowane do głowy i tułowia, a następnie przeskalowane do obszaru 4K.",
  "Individual cutouts cropped to the head and torso and scaled to 4K. These are not full-body images.":
    "Cutouty wykadrowane do głowy i tułowia oraz przeskalowane do 4K. Nie są to zdjęcia całej sylwetki.",
  "A composite made from players only—no substitutes, coaches, or staff. The captain is centered using the crossed-arms pose; the editor selects varied poses for the remaining players.":
    "Kompozycja wyłącznie z graczy — bez rezerwowych, trenerów i staffu. Kapitan znajduje się pośrodku w pozie ze skrzyżowanymi rękami, a edytor dobiera różne pozy pozostałych graczy.",
  "Admin settings": "Ustawienia administratora",
  "Media Day admin settings": "Ustawienia administratora Media Day",
  "Configure the active set. Changes are saved automatically.":
    "Skonfiguruj aktywny set. Zmiany zapisują się automatycznie.",
  "Active set": "Aktywny set",
  Individual: "Indywidualny",
  Team: "Teamowy",
  Workflow: "Tryb",
  Schedule: "Harmonogram",
  "Set the start time and timing defaults for this set.":
    "Ustaw godzinę rozpoczęcia i domyślne czasy dla tego setu.",
  "This set has no schedule items to configure.":
    "Ten set nie ma pozycji harmonogramu do skonfigurowania.",
  "Editorial visibility": "Widoczność editorialu",
  "Show all roles": "Pokaż wszystkie role",
  "Show all editorial roles": "Pokaż wszystkie role editorialu",
  "Include staff and other normally hidden editorial participants.":
    "Uwzględnij staff i innych standardowo ukrytych uczestników editorialu.",
  "Select a set to configure its administrative settings.":
    "Wybierz set, aby skonfigurować jego ustawienia administracyjne.",
  Unassigned: "Nieprzypisany",
  "Status history": "Historia statusu",
  First: "Pierwszy",
  Between: "Odstęp między",
  players: "graczami",
  "Time for shoot and selection": "Czas na zdjęcia i selekcję",
  "Editing time for one player": "Czas edycji jednego gracza",
  "The edit deadline uses": "Termin edycji uwzględnia",
  min: "min",
  "eligible players": "uprawnionych graczy",
  "Source JPG": "Źródłowy JPG",
  "Editorial source": "Źródło editorialu",
  "Editorial edited JPG": "Edytowany JPG editorialu",
  "Sync delayed": "Synchronizacja opóźniona",
  "file verification": "weryfikacja plików",
  "Exact filenames confirmed in the configured Voxis Working Folders.":
    "Dokładne nazwy plików potwierdzone w skonfigurowanych folderach roboczych Voxis.",
  "Waiting for the verification manifest to include all expected files.":
    "Oczekiwanie, aż manifest weryfikacji uwzględni wszystkie wymagane pliki.",
  Expected: "Oczekiwane",
  Found: "Znalezione",
  "Waiting for the first check.": "Oczekiwanie na pierwsze sprawdzenie.",
  Missing: "Brakujące",
  "All expected files confirmed.": "Potwierdzono wszystkie oczekiwane pliki.",
  "Last successful check": "Ostatnie udane sprawdzenie",
  "No successful check yet": "Brak udanego sprawdzenia",
  "Voxis sync delayed": "Synchronizacja Voxis opóźniona",
  Coach: "Trener",
  Substitute: "Rezerwowy",
  "Substitute Player": "Gracz rezerwowy",
  Manager: "Menedżer",
  Staff: "Staff",
  About: "Informacje o",
} as const;

type LanguageContextValue = {
  language: MediaDayStatusLanguage;
  locale: "en-US" | "pl-PL";
  setLanguage: (language: MediaDayStatusLanguage) => void;
  t: (phrase: string) => string;
  plural: (count: number, forms: [string, string, string]) => string;
};

const LanguageContext = React.createContext<LanguageContextValue | null>(null);
const storageKey = "media-day-status-language";

const setPageTitle = (language: MediaDayStatusLanguage) => {
  if (typeof document !== "undefined")
    document.title = language === "pl" ? polish["Media Day Status"] : "Media Day Status";
};

const initialLanguage = (): MediaDayStatusLanguage => {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem(storageKey);
  const language =
    stored === "en" || stored === "pl"
      ? stored
      : window.navigator.language.toLowerCase().startsWith("pl")
        ? "pl"
        : "en";
  setPageTitle(language);
  return language;
};

const polishPlural = (count: number, [one, few, many]: [string, string, string]) => {
  if (count === 1) return one;
  const lastTwo = count % 100;
  const last = count % 10;
  return last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14) ? few : many;
};

export function MediaDayStatusLanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguageState] = React.useState(initialLanguage);
  const setLanguage = (nextLanguage: MediaDayStatusLanguage) => {
    window.localStorage.setItem(storageKey, nextLanguage);
    setPageTitle(nextLanguage);
    setLanguageState(nextLanguage);
  };
  const value: LanguageContextValue = {
    language,
    locale: language === "pl" ? "pl-PL" : "en-US",
    setLanguage,
    t: (phrase) => (language === "pl" ? (polish[phrase as keyof typeof polish] ?? phrase) : phrase),
    plural: (count, forms) =>
      language === "pl" ? polishPlural(count, forms) : count === 1 ? forms[0] : forms[2],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useMediaDayStatusLanguage = () => {
  const context = React.useContext(LanguageContext);
  if (!context) throw new Error("MediaDayStatusLanguageProvider is missing.");
  return context;
};

export function MediaDayStatusLanguageSwitch() {
  const { language, setLanguage, t } = useMediaDayStatusLanguage();

  return (
    <div
      role="group"
      aria-label={t("Language")}
      className="flex h-8 items-center rounded-md border border-neutral-300 bg-white p-0.5 text-xs font-semibold text-neutral-700"
    >
      <Languages className="mx-1 size-3.5 text-neutral-500" aria-hidden="true" />
      {(["en", "pl"] as const).map((option) => (
        <button
          key={option}
          type="button"
          aria-label={option === "pl" ? "Polski" : "English"}
          aria-pressed={language === option}
          className={cn(
            "h-6 rounded-sm px-2 transition-colors focus-visible:ring-2 focus-visible:ring-neutral-500 focus-visible:outline-none",
            language === option ? "bg-neutral-950 text-white" : "hover:bg-neutral-100",
          )}
          onClick={() => setLanguage(option)}
        >
          {option.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
